<template>
  <div
    class="text-block"
    :style="block.style"
    contenteditable="true"
    @blur="onContentChange"
    @input="onInput"
    v-html="block.data.content"
  ></div>
</template>

<script setup lang="ts">
const props = defineProps<{
  block: any;
  pageIndex: number;
  blockIndex: number;
}>();

const emit = defineEmits<{
  update: [data: any];
  contentEdit: [];
}>();

function onContentChange(event: Event) {
  const target = event.target as HTMLElement;
  emit("update", { content: target.innerHTML });
  emit("contentEdit");
}

function onInput() {
  emit("contentEdit");
}
</script>

<style scoped>
.text-block {
  min-height: 20px;
  padding: 10px;

  &:focus {
    outline: 2px dashed #007bff;
    outline-offset: 2px;
  }
}
</style>
